import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const NavItem = ({
  to,
  active,
  'aria-current': ariaCurrent,
  ...rest
}) => {
  return (
    <li className={'nav-item' + (active ? ' active' : '')}>
      <Link
        to={to}
        aria-current={(active && ariaCurrent) || null}
        className='nav-link'
        {...rest}
      />
    </li>
  )
}

NavItem.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]).isRequired,
  active: PropTypes.bool,
  'aria-current': PropTypes.oneOf([
    'page',
    'step',
    'location',
    'date',
    'time',
    'true'
  ])
}

NavItem.defaultProps = {
  'aria-current': 'true'
}

export default NavItem



// WEBPACK FOOTER //
// ./src/components/Layout/NavItem.js